<template>
  <div class="inviteinaudit" :style="'background-image:url('+img.pagebg+');height:'+winHeight+'px;background-size: 100% '+winHeight+'px;'">
    <div class="div_mask">
      <div class="f-16 f-w" style="margin-top: 80px;align-items: center;display: inline-flex;color: #ffffff;">“富士范儿” <img class="sficon" :src="img.sficon">  影响力认证{{is_audit_name}}</div>
      <div class="f-16" style="margin-top: 14px;padding: 0 45px;color: #cccccc;"  v-if="is_audit==0">审核时间 1～3 个工作日</div>
      <div class="f-16" style="margin-top: 14px;padding: 0 45px;color: #cccccc;" @click="inviteAgain" v-if="is_audit==2">重新申请<img class="nextimg" :src="img.nextimg"></div>
      <!-- <div class="f-16" style="margin-top: 14px;padding: 0 45px;color: #999999;"></div> -->
      <div class="f-12" style="margin-top: 25px;padding: 2px 45px;color: #ffffff;">认证成功后，您将：</div>
      <div class="f-12" style="padding: 2px 45px;color: #ffffff;align-items: center;display: flex;justify-content: center;">获得「富士范儿」<img class="sficon" :src="img.sficon"> 影响力认证标识</div>
      <div class="f-12" style="padding: 2px 45px;color: #ffffff;">发布动态会获得更多曝光展示 </div>
      <div class="f-12" style="padding: 2px 45px;color: #ffffff;">受邀参与各种活动</div>
      <div class="f-12" style="padding: 2px 45px;color: #ffffff;">可以参与征文投稿、提问回答</div>
      <div class="f-12" style="padding: 2px 45px;color: #ffffff;">获得更多权益与专属勋章</div>
      <!-- <div class="info" v-if="is_audit==1">
        <span class="headbox">
          <img class="head" :src="otherinfo.avatar&&otherinfo.avatar.substring(0,5)=='https' ? otherinfo.avatar : img.avatar">
          <img class="headsficon" :src="img.border">
        </span>
        <span>
          <van-button class="follow buttonin" icon="plus" color="#605C6B" size="small">关 注</van-button>
        </span>
        <div class="f-14 f-w" style="color: #605C6B;margin-bottom: 20px;margin-top: 20px;">{{otherinfo.username}}</div>
        <div class="f-12" style="color:#979797;" v-if="list.length>0">
          <img class="member_car" :src="img.sficon">
          <span v-for="(item,index) in list" :key="'list_' + index" :style="index>0?'display: block;margin-left:18px;':''">{{item}}</span>
        </div>
        <div class="f-12" style="color: #979797;margin-top: 5px;" v-if="otherinfo.cars"><img class="member_car" :src="img.member_car">{{otherinfo.cars.title}} 车主</div>
      </div> -->
      <div style="margin-top: 25px;text-align: center">
        <img class="qrcode" :src="img.lexus">
      </div>
      <div class="f-12" style="color: #999999;margin-bottom: 30px;">长按保存富士范儿微信</div>
      <!-- <div class="invitebtn" @click="inviteAgain" v-if="is_audit==2">重新认证</div>
        <div class="invitebtn" @click="invitein" v-else>我知道了</div> -->
      </div>
    </div>
  </template>
  <script>
    import member from '../../../api/member/memberinfo';
    import common from '../../../api/common';
    import { mapState } from 'vuex';
    import { Grid, GridItem,Field,Button,Icon } from 'vant';
    export default {
      data () {
        return {
          winHeight:568,
          otherinfo:'',
          is_audit_name:'审核中',
          is_audit:0,
          list:[],
          img:{
            avatar:require('../../../assets/img/lexus/default.png'),
            sficon: require('../../../assets/img/subaru/approve/newicon.png'),
            lexus: require('../../../assets/img/subaru/approve/qrcode.png'),
            pagebg:require('../../../assets/img/subaru/approve/approve_bg.png'),
            member_car: require('../../../assets/img/subaru/member_car.png'),
            border: require('../../../assets/img/subaru/border.gif'),
          }
        }
      },
      computed: {
        ...mapState({
          user: state => state.param.user,
          source: state => state.param.source
        })
      },
      created () {
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.winHeight=h
        this.$store.commit('param/show', false)
        this.$appService.isShowReturn({state: false})
        this.$appService.isTabbar({state: true})

        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
        if(this.$route.query.token){
          this.source = this.$route.query.source
          this.token = this.$route.query.token
          this.user_id = this.$route.query.userid
          this.otherid = this.$route.query.otherid
          this.$store.dispatch('param/setToken', this.$route.query.token)
          this.getUserOther(this.$route.query.userid)
          this.getActivity(this.$route.query.userid)
        }else{
          this.source = this.$route.params.source
          this.token = this.$route.params.token
          this.$store.dispatch('param/setToken', this.$route.params.token)
          this.user_id = this.$route.params.user_id
          this.getUserOther(this.$route.params.user_id)
          this.getActivity(this.$route.params.user_id)
        }
        var params={
          event_code: '邀请认证',
          event_id: '',
          title: '',
          value: '',
          path: '/Subaru/Approve/SubaruInviteok.vue',
          user_id: this.user_id ? this.user_id : 0,
          source: this.source
        }
        common.BurialPoint(params).then(res => {
          if(res.data.state==1){

          }
        })
      },
      methods: {
        getActivity(id){
          var params={
            user_id:parseInt([id]),
          }
          common.getActivity(params,12).then(res => {
            if(res.data.state==1){
              if(res.data.data.enroll_share_pic){
                this.img.lexus=res.data.data.enroll_share_pic
              }
              if(res.data.data.background_pic){
                this.img.pagebg=res.data.data.background_pic
              }
              this.activeinfo=res.data.data

            }
          })
        },
        getUserOther(id){
          var params={
            user_id:parseInt([id]),
            source:this.source
          }
          member.userOther(params).then(res => {
            if(res.data.state==1){
              this.list=res.data.data.auth.title
              this.otherinfo=res.data.data
              
              if(res.data.data.auth.is_audit==0){//审核中
               this.is_audit=0
               this.is_audit_name='审核中'
            }else if(res.data.data.auth.is_audit==1){//审核通过
              this.is_audit=1
              this.is_audit_name='审核通过'
            }else if(res.data.data.auth.is_audit==2){//审核不通过
              this.is_audit=2
              this.is_audit_name='审核未通过'
            }
          }
        })
        },
        invitein(){
          if(this.source==5){
            wx.miniProgram.switchTab({url: '/pages/index/index'})
          }else{
            var params={
              url:this.weburl+'/subaru?source='+this.source ,
              isReturn: true 
            }
            this.$appService.openWebView(params)
          }
        },
        inviteAgain(){
          if(this.source==5){
            this.$router.push({name:'SubaruInvite',params:{source:this.source,token:this.token,user_id:this.user_id}});

          }else{
            var params={
              url:this.weburl+'/subaru/invite?source='+this.source ,
              isReturn: true 
            }
            this.$appService.openWebView(params)
          }
        }
      },
      components: {
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Field.name]:Field,
        [Button.name]:Button,
        [Icon.name]:Icon
      }
    }
  </script>
  <style lang="scss">
  .inviteinaudit{
    text-align: center;
    width: 100%;
    background-color: #000;
    .div_mask{
      width: 100%;
      height: 100%;
    // background: rgba(0,0,0,.8);
  }
  .sficon{
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
  .qrcode{
    width: 120px;
    height: 120px;
  }
  .invitebtn{
    font-size: 14px;
    text-align: center;
    background: #605C6B;
    color: #fff;
    padding:15px 30px;
    position: fixed;
    top: 73%;
    left: 34%;
  }
  .info{
    min-height: 150px;
    z-index: 99;
    margin:30px 15px;
    background-color: #fff;
    border-radius: 1.5px;
    padding:20px;
    box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
    .headbox{
      position: relative;
      width: 60px;
      height: 60px;
    }
    .head{
      width: 60px;
      height: 60px;
      border-radius: 1.5px;
    }
    .headsficon{
      width: 60px;
      height: 60px;
      position: absolute;
      // bottom: 7px;
      right: 0px;
    }
    .buttonin{
      float: right;
      margin-top: 15px;
    }
    .van-button--small{
      height: 28px;
      padding: 0 8px;
      line-height: 20px;
      border-radius: 1px;
      vertical-align: middle;
    }
    .van-button__icon{
      font-size: 10px;
    }
    .van-button__text{
      font-size: 11px;
    }
    .member_car{
      width: 15px;
      height: 15px;
    }
  }
  .nextimg{
    width: 13px;
    height:12px;
    margin-left: 5px;
  }
  *{
    -webkit-user-select: none;/*禁用手机浏览器的用户选择功能 */
    -moz-user-select: none;
    -webkit-touch-callout: none;
    -ms-user-select:none; /*IE10*/
    user-select:none;
  }
}
</style>
